import React, { Component } from 'react';
import { Button, Image, Form, Modal, Col, Row, FormControl } from 'react-bootstrap';
import Backend from '../../Backend';
import SendImage from '../../Images/send-button.svg';
import Connection from '../../Calls';
// import CameraImage from '../../../images/camera.svg';

class WalletAddressesCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false
    }
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }



  handleFocus(event) {
    event.target.select();
  }

  render() {
    return (
      <tr  onClick={()=>this.props.changeInfo(this.props.row)} className={(this.props.selected_uuid == this.props.row.uuid)?"hover-tr-table-wallets-generals active" :"hover-tr-table-wallets-generals" }style={{ cursor: "default" }}>
        <th className="text-table-container-addres-information">{this.props.row.payment_period}</th>
        <th className="text-table-container-addres-information">{this.props.row.uuid}</th>
        <th className={"text-table-container-addres-information " + this.props.row.status}>{this.props.row.status}</th>
      </tr>
    );
  }
} export default WalletAddressesCard;
